import { render, staticRenderFns } from "./bnvhidden.vue?vue&type=template&id=579888fd&"
import script from "./bnvhidden.vue?vue&type=script&lang=js&"
export * from "./bnvhidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports